/**
 * Kitchvo product purchase helpers
 * - USA (America/New_York) delivery timeline, Sat/Sun skipped
 * - Buy Now: add current variant to cart, then go to checkout
 */
(function () {
  'use strict';

  if (window.__kitchvoProductPurchaseLoaded) return;
  window.__kitchvoProductPurchaseLoaded = true;

  var TZ = 'America/New_York';
  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  function marketToday() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());
    var map = {};
    parts.forEach(function (p) {
      map[p.type] = p.value;
    });
    return new Date(Date.UTC(Number(map.year), Number(map.month) - 1, Number(map.day), 12, 0, 0));
  }

  function isWeekend(date) {
    var day = date.getUTCDay();
    return day === 0 || day === 6;
  }

  function addBusinessDays(start, count) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < count) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (!isWeekend(d)) added += 1;
    }
    return d;
  }

  function formatDate(date) {
    var month = MONTHS[date.getUTCMonth()];
    var day = date.getUTCDate();
    return month + ' ' + day;
  }

  function formatRange(start, end) {
    if (start.getTime() === end.getTime()) return formatDate(start);
    if (start.getUTCMonth() === end.getUTCMonth()) {
      return MONTHS[start.getUTCMonth()] + ' ' + start.getUTCDate() + '–' + end.getUTCDate();
    }
    return formatDate(start) + ' – ' + formatDate(end);
  }

  function fillTimeline(root) {
    var today = marketToday();
    var readyStart = addBusinessDays(today, 1);
    var readyEnd = addBusinessDays(today, 3);
    var deliveredStart = addBusinessDays(today, 7);
    var deliveredEnd = addBusinessDays(today, 15);

    var ordered = root.querySelector('[data-delivery-date="ordered"]');
    var ready = root.querySelector('[data-delivery-date="ready"]');
    var delivered = root.querySelector('[data-delivery-date="delivered"]');

    if (ordered) ordered.textContent = formatDate(today);
    if (ready) ready.textContent = formatRange(readyStart, readyEnd);
    if (delivered) delivered.textContent = formatRange(deliveredStart, deliveredEnd);
  }

  function initTimelines() {
    document.querySelectorAll('[data-kitchvo-delivery]').forEach(fillTimeline);
  }

  function buyNow(button) {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    var form = button.closest('form') || document.querySelector('[data-type="add-to-cart-form"]');
    if (!form) return;

    var idInput = form.querySelector('[name="id"]');
    var qtyInput =
      form.querySelector('[name="quantity"]') ||
      document.querySelector('input[name="quantity"][form="' + form.id + '"]') ||
      document.querySelector('.product-form__quantity input[name="quantity"]');

    var variantId = idInput && idInput.value;
    var quantity = qtyInput && qtyInput.value ? qtyInput.value : '1';
    if (!variantId) return;

    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    var formData = new FormData(form);
    if (!formData.get('quantity')) formData.set('quantity', quantity);
    if (!formData.get('id')) formData.set('id', variantId);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw new Error(data.description || 'Add to cart failed');
          window.location.href = '/checkout';
        });
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  function initBuyNow() {
    document.querySelectorAll('[data-kitchvo-buy-now]').forEach(function (button) {
      if (button.dataset.kitchvoBound === 'true') return;
      button.dataset.kitchvoBound = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        buyNow(button);
      });
    });
  }

  function init() {
    initTimelines();
    initBuyNow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
